import { mount } from 'mount-vue-component';
import mitt from 'mitt';
import DToast from './DToast.vue';
import { registerComponentProgrammatic, vueUse } from '../../../utils/plugins';
import { removeElement } from '../../../utils/helpers';

const ToastProgrammatic = (app) => {
  function processParams(params) {
    if (typeof params === 'string') return { message: params };
    return params;
  }

  function open(params) {
    const p = processParams(params);
    const emitter = mitt();
    const defaultParam = {
      message: p.message,
      emitter,
    };
    const propsData = Object.assign(defaultParam, params);
    const toast = mount(DToast, {
      props: propsData,
      app,
    });
    emitter.on('destroy', () => {
      emitter.all.clear();
      removeElement(toast.el);
      toast.destroy();
    });
    return toast;
  }

  function success(params) {
    return open({
      ...processParams(params),
      color: 'success',
    });
  }

  function error(params) {
    return open({
      ...processParams(params),
      color: 'error',
    });
  }

  return { open, error, success };
};

const Registered = {
  install(Vue) {
    registerComponentProgrammatic(Vue, '$toast', ToastProgrammatic(Vue));
  },
};

vueUse(Registered);

export default Registered;